export default __webpack_public_path__ + "static/media/kisspng-silo-agriculture-drawing-barn-clip-art-5aeb65cf00c304.2120032015253764630031.b74edfbe.png";